module.exports = require("dom-css");


//////////////////
// WEBPACK FOOTER
// external "dom-css"
// module id = 12
// module chunks = 0